import React from 'react';
import { getDisplayName } from './getDisplayName';

export const withScrollToTop = WrappedComponent => {
	class WithScrollToTop extends React.Component {
		componentDidMount() {
			window.scrollTo(0, 0);
		}

		render() {
			return <WrappedComponent {...this.props} />;
		}
	}

	WithScrollToTop.displayName = `WithScrollToTop(${getDisplayName(WrappedComponent)})`;

	return WithScrollToTop;
};



// WEBPACK FOOTER //
// ./src/utils/withScrollToTop.js